import { errorHandling } from "./errorHandling.js";
import { longPollFetch } from "./longPoll.js";
import { retry } from "./retry.js";
/**
 * Fetch wrapper to handle errors, retries, and long polling
 * @param args - The arguments for the fetch
 * @returns The response from the fetch
 * @example
 * ```ts
 * const response = await sherbertFetch(() => [
 *   "https://api.sherbert.cimpress.io/v2/assets/123",
 *   { method: "GET", headers: { Authorization: `Bearer ${token}` } },
 * ]);
 * ```
 */
export async function sherbertFetch(
// args is a function to make sure the arguments are recreated on retry.
// A new auth token might be needed
args) {
    const innerFetch = () => {
        const [url, init] = args();
        // If the body is FormData, ensure we don't set Content-Type header in node.js
        // Let Node.js set it automatically with the correct boundary
        if (init?.body instanceof FormData &&
            typeof XMLHttpRequest === "undefined") {
            const { headers, ...rest } = init;
            const newHeaders = new Headers(headers);
            newHeaders.delete("Content-Type");
            return fetch(url, { ...rest, headers: newHeaders });
        }
        return fetch(url, init);
    };
    return errorHandling(() => retry(() => longPollFetch(innerFetch)), args);
}
